import { forwardRef } from "react";

import classes from "./ReordonnerPopup.module.css";

import clsx from "clsx";
import { FaArrowsUpDown } from "react-icons/fa6";
import { STATES } from "react-sdk/activities/ActivityPedaInstance";

const ReordonnerProposition = ({proposition, dragged, hovered, corrected=0, index, ...props}, ref) => {

  let state;

  if(corrected === 1) {
    state = proposition.userIndex === proposition.initialIndex ? STATES.CORRECT : STATES.WRONG
  }
  if(corrected === 2) {
    state = proposition.userIndex === index ? STATES.CORRECT : STATES.MISSED
  }

  return (
    <div
    {...props}
    className={
      clsx(
        classes.ReordonnerProposition,
        dragged && classes.dragged,
        hovered && classes.hovered,
        state && classes["state_" + state])}
      ref={ref}
      style={props.style} >
        <FaArrowsUpDown className={classes.updownicon} />
      {proposition.Text}
    </div>
  )
}

export default forwardRef(ReordonnerProposition)